import get from 'lodash.get';
import {fetchARMScore, getARMAssessment} from "../../util/getArmScore";
import { isNotNullOrUndefined } from '../../../../services/util';

/**
 * Fetches the latest scores for a student
 * @param {string} studentId 
 * @param {*} assessments 
 * @returns {Promise<{areaScore: number, armScore: number, wcpm: number, createdAt: string, armAssessment: object, wcpmAssessment: object}>
 */
export default async function getLatestScores(studentId, assessments) {
  const areaScore = get(assessments, "[0].scores.areaScore");
  let armScore = assessments && assessments.length ? await fetchARMScore(studentId, assessments) : null;
  
  const wcpm = get(assessments, "[0].scores.wcpmScore");
  const createdAt = get(assessments, "[0].createdAt")
  const armAssessment = await getARMAssessment(studentId, assessments);

  if (isNotNullOrUndefined(armScore)) {
    if (parseInt(armScore) === armScore) {
      // armScore does not have any decimals
      armScore = parseFloat(armScore).toFixed(1);
    } else armScore = parseFloat(armScore).toFixed(2);
  }
  
  return {
    areaScore: areaScore && parseFloat(areaScore).toFixed(2),
    armScore,
    wcpm: wcpm && Math.round(wcpm),
    createdAt: createdAt,
    armAssessment, // assessment used to determine arm score
    wcpmAssessment: assessments?.[0], // assessment used to determine wcpm
  }
}

